import script from "./ConsultationActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConsultationActions.vue?vue&type=script&setup=true&lang=ts"

import "./ConsultationActions.vue?vue&type=style&index=0&id=c06802f2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c06802f2"]])

export default __exports__